import React from 'react';
import {
  Button,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import dateFormat from 'dateformat';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import DownloadIcon from '@mui/icons-material/Download';
import EditButton from 'common/EditButton/EditButton';
import downloadFileWithAuth from 'helpers/downloadFileWithAuth';
import { Agreement } from 'store/agreements/interfaces';

interface AgreementItemProps {
  agreement: Agreement;
}

function AgreementItem({ agreement }: AgreementItemProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">{agreement.type}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">{agreement.variant}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography variant="body2">
          {dateFormat(agreement.dateFrom, 'yyyy-mm-dd')}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {agreement.dateTo ? (
          <Typography variant="body2">
            {dateFormat(agreement.dateTo, 'yyyy-mm-dd')}
          </Typography>
        ) : (
          <AllInclusiveIcon fontSize="large" />
        )}
      </TableCell>
      <TableCell align="center">
        {agreement.files ? (
          agreement.files.map((file) => (
            <IconButton
              key={file.id}
              onClick={() => downloadFileWithAuth(file.url, file.id)}
            >
              <DownloadIcon fontSize="large" />
            </IconButton>
          ))
        ) : (
          <Button
            variant="contained"
            color="error"
            onClick={() =>
              navigate(`/agreements/${agreement.id}`, {
                state: { tabValue: '2' },
              })
            }
          >
            {t('button.upload_missing_file')}
          </Button>
        )}
      </TableCell>
      <TableCell align="right">
        <EditButton navigateTo={`/agreements/${agreement.id}`} />
      </TableCell>
    </TableRow>
  );
}

export default AgreementItem;
